export const FETCH_PUBLIC_SCHEDULED_DATE_SCHEDULES_START = 'FETCH_PUBLIC_SCHEDULED_DATE_SCHEDULES_START';
export const FETCH_PUBLIC_SCHEDULED_DATE_SCHEDULES_ERROR = 'FETCH_PUBLIC_SCHEDULED_DATE_SCHEDULES_ERROR';
export const FETCH_PUBLIC_SCHEDULED_DATE_SCHEDULES_NOT_FOUND = 'FETCH_PUBLIC_SCHEDULED_DATE_SCHEDULES_NOT_FOUND';
export const RECEIVE_PUBLIC_SCHEDULED_DATE_SCHEDULES = 'RECEIVE_PUBLIC_SCHEDULED_DATE_SCHEDULES';
export const CLEAR_PUBLIC_SCHEDULED_DATE_SCHEDULES_STORE = 'CLEAR_PUBLIC_SCHEDULED_DATE_SCHEDULES_STORE';

export const FETCH_PUBLIC_SCHEDULE_DETAILS_START = 'FETCH_PUBLIC_SCHEDULE_DETAILS_START';
export const FETCH_PUBLIC_SCHEDULE_DETAILS_ERROR = 'FETCH_PUBLIC_SCHEDULE_DETAILS_ERROR';
export const FETCH_PUBLIC_SCHEDULE_DETAILS_NOT_FOUND = 'FETCH_PUBLIC_SCHEDULE_DETAILS_NOT_FOUND';
export const RECEIVE_PUBLIC_SCHEDULE_DETAILS = 'RECEIVE_PUBLIC_SCHEDULE_DETAILS';
export const CLEAR_PUBLIC_SCHEDULE_DETAILS_STORE = 'CLEAR_PUBLIC_SCHEDULE_DETAILS_STORE';

export const FETCH_PUBLIC_SCHEDULED_DATES_START = 'FETCH_PUBLIC_SCHEDULED_DATES_START';
export const FETCH_PUBLIC_SCHEDULED_DATES_ERROR = 'FETCH_PUBLIC_SCHEDULED_DATES_ERROR';
export const FETCH_PUBLIC_SCHEDULED_DATES_NOT_FOUND = 'FETCH_PUBLIC_SCHEDULED_DATES_NOT_FOUND';
export const RECEIVE_PUBLIC_SCHEDULED_DATES = 'RECEIVE_PUBLIC_SCHEDULED_DATES';
export const CLEAR_PUBLIC_SCHEDULED_DATES_STORE = 'CLEAR_PUBLIC_SCHEDULED_DATES_STORE';



// WEBPACK FOOTER //
// ./src/store/modules/public/mutation-types.js